import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { TranslatorContext } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import styles from '../envImpairment.module.scss'

import metadata from './ProductsCoverageSelectionComponent.metadata.json5';

function ProductsCoverageSelectionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductsCoverageSelectionComponent');
    const translator = useContext(TranslatorContext);
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doeTheAppReqPolLiaCov4Text: {
            disabled: true,
            visible: !_.isUndefined(modelVM.value.doeTheAppReqPolLiaCov4) && modelVM.value.doeTheAppReqPolLiaCov4
        },
        productType: {
            availableValues: _.filter(submissionVM.lobData.envLin.coverables.envImpairmentCoverable.productsCoverageSelection.productType.aspects.availableValues[0].typelist.filters[4].codes, {
                
            }).map((i) => {
                const name = translator({ id: i.name });

                return { code: i.code, name }
            })
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductsCoverageSelectionComponent.propTypes = wizardProps;
export default withRouter(ProductsCoverageSelectionComponent);
